import { Profile } from '../generated/graphql';

// we could show the email instead of the username, but for the sake of consistency we should pick one - so I picked username
function buildUserDisplayName(
  user?: {
    username: string;
    profile?: Pick<Profile, 'firstName' | 'lastName'> | null;
  } | null,
): string {
  if (!user) {
    return '-';
  }

  const { profile } = user;
  if (profile) {
    const { firstName, lastName } = profile;
    if (firstName && lastName) {
      return `${lastName}, ${firstName}`;
    }
  }

  const { username } = user;
  return username ?? '-';
}

export default buildUserDisplayName;
